import { render } from "./ListaDeseo.vue?vue&type=template&id=61d19a56&scoped=true"
import script from "./ListaDeseo.vue?vue&type=script&lang=js"
export * from "./ListaDeseo.vue?vue&type=script&lang=js"

import "./ListaDeseo.vue?vue&type=style&index=0&id=61d19a56&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d19a56"]])

export default __exports__